import { render } from "./ProfileName.vue?vue&type=template&id=3f2dc66e&scoped=true"
import script from "./ProfileName.vue?vue&type=script&lang=js"
export * from "./ProfileName.vue?vue&type=script&lang=js"

import "./ProfileName.vue?vue&type=style&index=0&id=3f2dc66e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f2dc66e"]])

export default __exports__